<template>
  <PreviewModal>
    <div class="import-preview">
      <div class="import-preview__wrapper">
        <div class="import-preview__wrapper--links">
          <div class="links-wrapper">
            <p class="links-wrapper__description">{{ track.description }}</p>
            <p>
              <a v-if="track.artist" style="color: blue" href="#">{{ track.artist.name }} - </a>
              <a href="#">{{ track.title }}</a>
            </p>
            <p><a href="#">{{ track.ffm_link }}</a></p>
            <p v-for="link in track.smartLinks" :key="link.key">
              {{ link.description }} <a href="#">{{ link.value }} </a>
            </p>
            <p>License: syncbaby:lVhYAxbuq7lnkn8HnDVacYc5v4o</p>
          </div>
        </div>
        <div class="import-preview__wrapper--restrictions">
          <strong>RESTRICTIONS</strong>
          <br>
          <strong>Cannot be used in videos containing:</strong>
          <br>
          <table class="restrictions-table">
            <tr v-for="restriction in transformRestrictions" :key="new Date().getTime() + restriction">

              <td v-for="n in restriction" :key="new Date().getTime() + n">
                <span class="restrictions-table__icon">&#10007;</span>
                <strong>{{ n.toUpperCase() }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </PreviewModal>
</template>

<script>
import PreviewModal from '@/global/components/Preview'

export default {
  components: {
    PreviewModal
  },

  props: {
    restrictions: { default: () => [], type: Array },
    track: { default: () => ({}), type: Object }
  },

  computed: {
    transformRestrictions() {
      let newArr = []
      let restrictions = this.track.restrictions && this.track.restrictions.length > 0
          ? this.track.restrictions
          : this.restrictions

      restrictions.forEach(restriction => {
        let lastItem = newArr[newArr.length - 1]

        if (lastItem) {
          if (lastItem.length !== 2) {

            let index = newArr.indexOf(lastItem)
            newArr[index].push(restriction)
            return
          }
        }
        newArr.push([restriction])
      })
      return newArr
    }
  }
}
</script>

<style scoped lang="scss">
.import-preview {

  &__wrapper {
    padding-bottom: 20px;
    width: 640px;
    margin: 0 auto;

    &--links {
      margin-bottom: 20px;

      .links-wrapper {
        border: 1px solid gray;
        padding: 20px;
        text-align: left;

        a {
          color: blue;
        }

        &__description {
          margin-bottom: 15px;
          white-space: pre-line;
          word-break: break-word
        }
      }
    }

    &--restrictions {
      margin-bottom: 20px;

      .restrictions-table {
        border: 1px solid gray;
        width: 100%;
        padding: 20px;

        &__icon {
          display: inline-block;
          margin-right: 10px;
          color:red
        }
      }
    }
  }
}
</style>
